const DISTANCE = 150;
const DURATION = 500;

const ob = new IntersectionObserver((entries) => {
    for (const entry of entries) {
        console.log(entry)
    }
});

export default {
    mounted(el) {
        const animation = el.animate([
            {transform: `translateY(${DISTANCE}px)`, opacity: 0.5},
            {transform: `translateY(0px)`, opacity: 1}
        ], {
            duration: DURATION,
            easing: 'ease-in-out',
            fill: 'forwards',
        })
        animation.pause()
        ob.observe(el)
    },
    unmounted(el) {
        ob.unobserve(el)
    }
}
